/** Funciones basicas de NBF javascript */
var nbf = function(){
	//manejadores globales de setTimeout y setInterval
	var tTimeout = [];

	/**
	 * Obtiene la representación JSON de un objeto
	 * @param {*} obj Objeto a representar
	 * @returns {string} Cadena en formato JSON
	 */
	function toJSON(obj){
		if($.isPlainObject(obj) || $.isArray(obj))
			return JSON.stringify(obj);
		else
			return obj;
	}

	/**
	 * Lee un contenido en JSON
	 * @param {string} obj Cadena en formato JSON
	 * @returns {Object} Objeto generado (excepción si falla)
	 */
	function parseJSON(obj){
		if(obj && obj.indexOf && (obj.indexOf("{")>-1 || obj.indexOf("[")>-1)){
			try{
				return JSON.parse(obj);
			}catch(e){
				return obj;
			}
		}else
			return obj;
	}

	/**
	 * Lee unos parámetros en formato de formulario jQuery y crea un objeto
	 * @param {Object} valoresForm Valores del formulario (pares value, name)
	 * @return {Object} Objeto leído
	 */
	function parseFormVals(valoresForm){
		var obj = {};
		for(var i in valoresForm)
			obj[valoresForm[i].name] = valoresForm[i].value;
		return obj;
	}

	/**
	 * Carga el script JS pasado
	 * @param {string} urlJs Script a cargar
	 * @param {function} funcionRetorno Función a ejecutar si la carga es ok
	 */
	function cargarJs(urlJs,funcionRetorno){
	    var script = document.createElement("script");
	    script.setAttribute("type","text/javascript");
	    if(funcionRetorno){
	        script.onreadystatechange = function(){
	            if(this.readyState=='complete' || this.readyState=='loaded')
	                funcionRetorno();
	        };
	        script.onload = funcionRetorno;
	    }
	    script.setAttribute("src",urlJs);
	    document.getElementsByTagName("head")[0].appendChild(script);
	}

	/**
	 * Determina si el objeto pasado está definido
	 * @param {string} nombreObjeto Nombre del objeto a comprobar
	 * @param {string} tipo Tipo a comprobar (por defecto "object")
	 * @returns {bool} True si está definido, false en caso contrario
	 */
	function objetoDefinido(nombreObjeto,tipo){
		if(!tipo)
	        tipo = "object";
	    return eval("(typeof "+nombreObjeto+").toLowerCase() == '"+tipo.toLowerCase()+"'");
	}

	/**
	 * Codifica el dato pasado en un class
	 * @param {*} dato Dato a codificar
	 * @returns {string} Clase a usar
	 */
	function codificarDatoClass(dato){
		return "d-"+$.base64Encode(nbf.toJSON(dato).toString()).replace(/=/g,"_")+"-d";
	}

	/**
	 * Crea un class css con la clase php del objeto pasado
	 * @param {string} prefijo Prefijo a utilizar
	 * @param {string} clase Class php del objeto a codificar
	 */
	function crearClassObjetoBase(prefijo,clase){
		var cls = clase.replace(/\\/g,"");
		return prefijo+cls.charAt(0).toUpperCase()+cls.substring(1);
	}

	/**
	 * Extrae los datos codificados en el class del elemento pasado
	 * @param {jQuery} jqElem Elemento jQuery del que se leera su class
	 * @returns {object} Datos leídos
	 */
	function extraerDatos(jqElem){
		var classCss = jqElem.attr("class");
		var patron = /d\-[a-zA-Z0-9_]+\-d/;
		var coin = patron.exec(classCss);
		if(coin){
			var ret = nbf.parseJSON($.base64Decode(coin.toString().replace(/-d$/,"").replace(/^d-/,"").replace(/_/g,"=")));
			if(isNaN(ret) || ret.indexOf("0")===0) //es un string o cualquier otra cosa
				return ret;
			else if(ret%1==0) //es un número entero
				return parseInt(ret);
			else //es un decimal
				return parseFloat(ret);
		}
		return null;
	}

	/**
	 * Genera un id aleatorio para aplicar sobre un elemento recien creado
	 * @return {string} Id recien creado
	 */
	function generarIdAleatorio(){
	    var n = parseInt(Math.random()*1000000);
	    while($("#nbf"+n).size()>0)
	        n = parseInt(Math.random()*1000000);
	    return "nbf"+n;
	}

	/**
	 * Ejecuta en servidor la función pasada
	 * @param {string} funcion Función a ejecutar (ruta absoluta)
	 * @param {Array} parametros Lista de parámetros de la función
	 * @param {function} funcionOk Función a ejecutar con la respuesta en caso de ok
	 * @return {jqXHR} Petición ajax recién realizada (permite abortarla, etc)
	 */
	function ejecutar(funcion,parametros,funcionOk){
		return ejecutarBase(funcion,parametros,true,funcionOk);
	}

	/**
	 * Ejecuta en servidor la función pasada de forma síncrona
	 * @param {string} funcion Función a ejecutar (ruta absoluta)
	 * @param {Array} parametros Lista de parámetros de la función
	 * @return {Object} Valor devuelto
	 */
	function ejecutarSync(funcion,parametros){
		return ejecutarBase(funcion,parametros,false);
	}

	//uso interno
	function ejecutarBase(funcion,parametros,async,funcionOk){
		var procesarRespuesta = function(respuesta){
			return nbf.parseJSON(respuesta);
		};
		var ret = $.ajax(
			{
				type: 'POST',
				async: async,
				url: (nbf.config.raizUrl()?nbf.config.raizUrl():"")+"/nbf/pag/ajax-exec.php?"+Math.random(),
				data: {"func":funcion,"params":nbf.toJSON(parametros),"url":window.location.toString()}
			}
		);
		if(!async)
			return procesarRespuesta(ret.responseText);
		else{
			ret.done(
				function(data){
					if(funcionOk)
						funcionOk(procesarRespuesta(data));
				}
			);
			ret.fail(
				function(){
					if(funcionOk)
						funcionOk({"status":"fail"});
				}
			);
			return ret;
		}
	}

	/**
	 * Ejecuta en servidor la función pasada dejando en $_FILES los archivos pasados
	 * @param {Files} files event.target.files recibido del change de un file input
	 * @param {string} Función a ejecutar (ruta absoluta)
	 * @param {Array} Lista de parámetros de la función
	 * @param {function} Función de vuelta
	 * @return mixed Valor devuelto
	 */
	function ejecutarSubirArchivos(files,funcion,parametros,funcionOk){
		var data = new FormData();
		$.each(files,function(key,value){data.append(key,value);});

		$.ajax(
	    	{
		        url: (nbf.config.raizUrl()?nbf.config.raizUrl():"")+"/nbf/pag/ajax-exec.php?func="+funcion+"&params="+encodeURI(nbf.toJSON(parametros))+"&url="+window.location.toString()+"v="+Math.random(),
		        type: 'POST',
		        data: data,
		        cache: false,
		        dataType: 'json',
		        processData: false,
		        contentType: false,
		        success: function(data,textStatus,jqXHR){
	        		if(funcionOk)
						funcionOk(nbf.parseJSON(data));
		        },
		        error: function(jqXHR, textStatus, errorThrown){
		        	dbg(textStatus);
		        }
	    	}
	    );
	}

	/**
	 * Lanza la función pasada cuando hayan pasado X milisegundos (cancelando ejecuciones pendientes de esta funcion)
	 * @param {int} milisegundos Milisegundos a esperar para lanzarla
	 * @param {function} funcion Función a lanzar
	 * @param {string} clave Clave a usar para agrupar ejecuciones (si no se pasa, se usa el cuerpo de la función)
	 * @return {int} Valor retornado por setTimeout
	 */
	function lanzar(milisegundos,funcion,clave){
		if(!clave)
			clave = funcion;

		if(tTimeout[clave])
			clearTimeout(tTimeout[clave]);
		tTimeout[clave] = setTimeout(
			function(){
				funcion();
			},
			milisegundos
		);
		return tTimeout[clave];
	}

	//Asocia una función al evento device ready (cordova)
	function deviceReady(f){
		if(document.URL.indexOf("http")===-1)
			document.addEventListener("deviceready",f,false);
		else
			f();
	}

	return {
		"toJSON":toJSON,
		"parseJSON":parseJSON,
		"parseFormVals":parseFormVals,
		"cargarJs":cargarJs,
		"objetoDefinido":objetoDefinido,
		"codificarDatoClass":codificarDatoClass,
		"crearClassObjetoBase":crearClassObjetoBase,
		"extraerDatos":extraerDatos,
		"generarIdAleatorio":generarIdAleatorio,
		"ejecutar":ejecutar,
		"ejecutarSync":ejecutarSync,
		"ejecutarSubirArchivos":ejecutarSubirArchivos,
		"lanzar":lanzar,
		"deviceReady":deviceReady
	};
}();

//alias para console.log
window.dbg= function dbg(obj){
	if(console && !window.cordova)
		console.log(obj);
	else
		alert(nbf.toJSON(obj));
}

//depura un mensaje por e-mail
window.dbgMail = function dbgMail(obj,asunto){
	nbf.ejecutar("\\nbf\\errores::ajaxDbgMail",[obj,asunto?asunto:null]);
}

window.nbf = nbf;// TODO: Intentar cambiar la filosofía a módulos reales
